import { render, staticRenderFns } from "./qtxxDetail.vue?vue&type=template&id=47168794&scoped=true"
import script from "./qtxxDetail.vue?vue&type=script&lang=js"
export * from "./qtxxDetail.vue?vue&type=script&lang=js"
import style0 from "./qtxxDetail.vue?vue&type=style&index=0&id=47168794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47168794",
  null
  
)

export default component.exports